import { YesNo } from '@youscience/commonapp-service-common';

import useRecommenderStore from '@store/RecommenderStore';
import useRecommenderProfileStore, { SectionName } from '@store/RecommenderProfileStore';

import SectionAccordion from '@components/SectionAccordion';
import RadioButtonGroupWithClearButton from '@components/RadioGroupWithClearButton';

import { REQUIRED_FIELD_MESSAGE } from '@constants/texts';

import { StyledCard } from '@pages/RecommenderSpace/components/Card.styles';

import { SchoolDetailsProps, TranscriptsFields } from '../../types';
import useFormSection from '@pages/RecommenderSpace/hooks/useFormSection';

export const Transcripts = ({ onExpand, isExtended, isSaved }: SchoolDetailsProps<TranscriptsFields>) => {
  const { recommenderProfile } = useRecommenderStore((store) => store);

  const {
    initialState: { transcripts: initialState },
    formState: { transcripts: formState },
  } = useRecommenderProfileStore((store) => store);

  const isShowErrors = new URLSearchParams(window.location.search).get('showErrors') === 'true';
  const isFilledAllRequiredFields = formState.data.currentCoursesListed && formState.data.testsIncluded;

  const initializeValues = () => {
    const { currentCoursesListed, testsIncluded } = recommenderProfile?.schoolProfile?.transcripts ?? {};

    return {
      currentCoursesListed,
      testsIncluded,
    };
  };

  const { handleRadioChange, updateFormValues } = useFormSection<TranscriptsFields>({
    initialState,
    formState,
    initializeValues,
    sectionName: SectionName.Transcripts,
  });

  return (
    <SectionAccordion
      title={'Transcripts'}
      isExpanded={isExtended}
      onChange={onExpand}
      isChanged={formState.hasChanged}
      isError={isShowErrors && !isFilledAllRequiredFields}
    >
      {Object.keys(formState.data).length === 0 ? null : (
        <StyledCard>
          <RadioButtonGroupWithClearButton
            title="Are current courses listed on the transcript?"
            name="currentCoursesListed"
            value={formState.data.currentCoursesListed ?? undefined}
            options={YesNo}
            required
            error={isShowErrors && !formState.data.currentCoursesListed}
            helperText={isShowErrors && !formState.data.currentCoursesListed ? REQUIRED_FIELD_MESSAGE : ''}
            handleRadioChange={handleRadioChange}
            handleClear={() => updateFormValues({ currentCoursesListed: null })}
          />

          <RadioButtonGroupWithClearButton
            title="Are college entrance examination scores included with or visible on the transcript?"
            name="testsIncluded"
            value={formState.data.testsIncluded ?? undefined}
            options={YesNo}
            required
            error={isShowErrors && !formState.data.testsIncluded}
            helperText={isShowErrors && !formState.data.testsIncluded ? REQUIRED_FIELD_MESSAGE : ''}
            handleRadioChange={handleRadioChange}
            handleClear={() => updateFormValues({ testsIncluded: null })}
          />
        </StyledCard>
      )}
    </SectionAccordion>
  );
};
